<div class="insurance-coverage-control">
    <form class="insurance-coverage-control__form" [formGroup]="form">
        <div *ngFor="let collection of coverageControl.collections">
            <div
                class="insurance-coverage-control__panel-highlighted"
                [class.insurance-coverage-control__panel-highlighted--base]="
                    collection.label === coverageCollectionLabelEnum.Base
                "
            >
                <h3
                    class="insurance-coverage-control__header"
                    *ngIf="collection.label && collection.label === coverageCollectionLabelEnum.Base"
                >
                    Basisdekking
                </h3>
                <h3
                    class="insurance-coverage-control__header"
                    *ngIf="collection.label && collection.label === coverageCollectionLabelEnum.Extra"
                >
                    Aanvullende dekking
                </h3>
                <ng-container *ngFor="let group of collection.groups; let i = index">
                    <ng-container [ngSwitch]="group.type">
                        <ins-coverage-card
                            *ngSwitchCase="coverageGroupTypeEnum.Card"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-card>
                        <ins-coverage-default
                            *ngSwitchCase="coverageGroupTypeEnum.Default"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            [class.hidden]="group.hidden"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-default>
                        <ins-coverage-disabled
                            *ngSwitchCase="coverageGroupTypeEnum.Disabled"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-disabled>
                        <ins-coverage-implicit
                            *ngSwitchCase="coverageGroupTypeEnum.Implicit"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-implicit>
                        <ins-coverage-radio
                            *ngSwitchCase="coverageGroupTypeEnum.Radio"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-radio>
                        <ins-coverage-toggle
                            *ngSwitchCase="coverageGroupTypeEnum.Toggle"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-toggle>
                        <ins-coverage-table
                            *ngSwitchCase="coverageGroupTypeEnum.Table"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-table>
                        <ins-coverage-dynamic
                            *ngSwitchCase="coverageGroupTypeEnum.Dynamic"
                            [selectedIds]="purchasedCoverageIds"
                            [group]="group"
                            [formControlName]="group.id"
                            [ngClass]="group.layout"
                            class="insurance-coverage-control__module"
                            id="{{ i }}-{{ group.id }}"
                        ></ins-coverage-dynamic>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </form>


    <div class="insurance-coverage-control__premium">
        <wuc-card padding="large" cardStyle="tertiary">
            <wuc-icon-ui class="insurance-coverage-control__premium-expand-icon"
                         [icon]="detailsExpand ? 'arrow-up-bold' : 'arrow-down-bold'"
                         type="primary"
                         size="xs"
                         (click)="detailsExpand = !detailsExpand"
            ></wuc-icon-ui>
            <ins-premium-summary
                [purchasedProduct]="purchasedProduct"
                [coverages]="purchasedCoverages"
                [expand]="detailsExpand"
            ></ins-premium-summary>
            <div class="insurance-coverage-control__premium-info">
                <small>
                    Alle genoemde prijzen zijn in euro's inclusief assurantiebelasting. En exclusief het
                    geld dat u achteraf misschien terugkrijgt in de vorm van JaarBalans.
                    <a href="" (click)="getInfo()">Wat is dit?</a>
                </small>
            </div>
        </wuc-card>
    </div>
</div>
